import "babel-polyfill"
import React from "react"
import { render } from "react-dom"
import {compact} from "lodash"
import {Helmet} from "react-helmet"
import Catalogo from "./catalogo"
import Admin from "./admin"
import Login from "./admin/components/Login.jsx"


const mainPath = compact(document.location.pathname.split("/"))[0]

const linkStyle = {
  borderBottom: "1px solid #ccc",
  textAlign: "center",
  height: "10vh",
  lineHeight: "10vh",
  fontSize: "5vh"
}

const Home = () => (
  <div>
    <div style={linkStyle}>
      <a href="/">
        Catalogo
      </a>
    </div>
    <div style={linkStyle}>
      <a href="/estudiantes">
        Estudiantes
      </a>
    </div>
    <div style={linkStyle}>
      <a href="/login">
        Login administración
      </a>
    </div>
  </div>
)

const foo = {
  catalogo: <Catalogo />,
  private: <Admin />,
  partner: <Admin />,
  login: <Login />,
  home: <Home />,
}

render(
  foo[compact(document.location.pathname.split("/"))[0]] || <Catalogo />,
  document.getElementById("root")
)



// WEBPACK FOOTER //
// ./src/app/index.js